<template>
    <div></div>
</template>


<script>
export default {
    name: "Blank",
    data() {
        return {
            //url: "/not-found"
        }
    }
}
</script>

<style lang="stylus">

</style>


